import { api } from './api';

export interface LoginRequest {
  email: string;
  senha: string;
}

export interface LoginRequestFrontend {
  email: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  tipoToken: string;
  expiracao: string;
  usuario: {
    id: string;
    nome: string;
    email: string;
    ativo: boolean;
    papeis: string[]; // Códigos dos papéis
    papeisNomes?: string[]; // Nomes dos papéis
    pessoaId?: number;
    fotoUrl?: string;
  };
}

export const authService = {
  /**
   * Realiza login do usuário
   */
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/Auth/login', credentials);
    
    // Armazenar token no localStorage
    if (response.token) {
      localStorage.setItem('token', response.token);
    }
    
    return response;
  },

  /**
   * Realiza logout do usuário
   * Apenas limpa o localStorage. A navegação é feita pelo React Router.
   */
  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  },

  /**
   * Obtém o token atual
   */
  getToken(): string | null {
    return localStorage.getItem('token');
  },

  /**
   * Verifica se o usuário está autenticado
   */
  isAuthenticated(): boolean {
    const token = this.getToken();
    return !!token;
  },

  /**
   * Valida o token atual
   */
  async validateToken(): Promise<boolean> {
    const token = this.getToken();
    if (!token) return false;

    try {
      await api.post('/Auth/validate', token);
      return true;
    } catch {
      this.logout();
      return false;
    }
  },

  /**
   * Obtém dados do usuário autenticado
   */
  async obterUsuarioAutenticado(): Promise<LoginResponse['usuario']> {
    const response = await api.get<any>('/Auth/me');
    // Garantir que papeis seja sempre um array de strings
    const papeis = response.papeis || response.Papeis || [];
    const papeisNormalizados = Array.isArray(papeis) 
      ? papeis.map((p: any) => String(p)) 
      : [];
    
    return {
      id: response.id || response.Id,
      nome: response.nome || response.Nome,
      email: response.email || response.Email,
      ativo: response.ativo ?? response.Ativo,
      papeis: papeisNormalizados,
      papeisNomes: response.papeisNomes || response.PapeisNomes || [],
      pessoaId: response.pessoaId || response.PessoaId,
      fotoUrl: response.fotoUrl || response.FotoUrl
    };
  }
};
